//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import props from './props'
import { go } from '@/libs/router'

export default {
  props: props(),
  data () {
    return {
      hasRightTitleSlot: false
    }
  },
  created () {
    this.hasRightTitleSlot = !!this.$slots.rightTitle
  },
  methods: {
    onClick () {
      !this.userInterface && this.link && go(this.link, this.$router)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/panel-item/index.vue